import { createIntroOfferProductId } from '~/shared/helpers/createIntroOfferProductId'
import { createProductId } from '~/shared/helpers/createProductId'
import { ISubscription } from '~/shared/types/subscriptionsTypes'

export const getSubscriptionProductId = ({
  lookupKey,
  trialLookupKey,
  trialPrices,
  mainPrices,
}: ISubscription): string =>
  trialLookupKey
    ? createIntroOfferProductId({
        priceId: lookupKey,
        trialPriceId: trialLookupKey,
        trialPeriodQuantity: trialPrices.durationDays,
      })
    : createProductId({
        periodName: mainPrices.periodName,
        periodQuantity: mainPrices.periodQuantity,
        price: mainPrices.fullPrice,
      })
